import 'leaflet';

declare const L: any;

let canvasMarkerRegistered = false;

export function ensureCanvasMarkerPlugin(): void {
  if (canvasMarkerRegistered || typeof L === 'undefined') {
    return;
  }

  if (typeof L.canvasMarker === 'function') {
    canvasMarkerRegistered = true;
    return;
  }

  L.Canvas.include({
    _updateImg(layer) {
      const { img } = layer.options;
      const point = layer._point.round();
      point.x += img.offset.x;
      point.y += img.offset.y;

      if (img.rotate) {
        this._ctx.save();
        this._ctx.translate(point.x, point.y);
        this._ctx.rotate((img.rotate * Math.PI) / 180);
        this._ctx.drawImage(img.el, -img.size[0] / 2, -img.size[1] / 2, img.size[0], img.size[1]);
        this._ctx.restore();
      } else {
        this._ctx.drawImage(img.el, point.x - img.size[0] / 2, point.y - img.size[1] / 2, img.size[0], img.size[1]);
      }
    },
  });

  const angleCrds = (map, prevLatlng, latlng) => {
    if (!latlng || !prevLatlng) {
      return 0;
    }

    const start = map.project(prevLatlng);
    const end = map.project(latlng);
    return (Math.atan2(start.y - end.y, start.x - end.x) / Math.PI) * 180 - 90;
  };

  const defaultImgOptions = {
    rotate: 0,
    size: [40, 40],
    offset: { x: 0, y: 0 },
  };

  const CanvasMarker = L.CircleMarker.extend({
    _updatePath() {
      if (!this.options.img || !this.options.img.url) {
        return;
      }

      if (!this.options.img.el) {
        this.options.img = { ...defaultImgOptions, ...this.options.img };
        this.options.img.rotate += angleCrds(this._map, this.options.prevLatlng, this._latlng);
        const img = document.createElement('img');
        img.src = this.options.img.url;
        this.options.img.el = img;
        img.onload = () => {
          this.redraw();
        };
        img.onerror = () => {
          this.options.img = null;
        };
      } else {
        this._renderer._updateImg(this);
      }
    },
  });

  L.canvasMarker = function (...options) {
    try {
      const imgOptionIndex = options.findIndex((option) => typeof option === 'object' && option.img);
      if (imgOptionIndex + 1) {
        if (!options[imgOptionIndex].radius && options[imgOptionIndex].img?.size) {
          options[imgOptionIndex].radius = Math.ceil(Math.max(...options[imgOptionIndex].img.size) / 2);
        }
        if (options[imgOptionIndex].forcePane !== true && options[imgOptionIndex].pane) {
          delete options[imgOptionIndex].pane;
        }
      }
    } catch {}

    return new CanvasMarker(...options);
  };

  canvasMarkerRegistered = true;
}
